module.exports = __webpack_public_path__ + "media/ר.85842067.mp3";